var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Sidebar",class:{ 'SidebarHide' : this.open }},[_c('SidebarCart'),_c('SidebarFilter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }